import React from 'react';
import './scss/_confirmationPopup.scss';

function ConfirmationPopup({ 
  isOpen, 
  onClose, 
  onContinue, 
  questionText, 
  cancelText = "Cancel",
  continueText = "Continue" 
}) {
  
  const handleCancel = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleContinue = () => {
    
    if (onContinue) {
      onContinue();
    }
    if (onClose) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="confirm-dialog-overlay" onClick={handleCancel}></div>
      <div className="confirm-dialog-container">
        {/* Header */}
        {/* <div className="confirm-dialog-header">
          <h1 className="confirm-dialog-title">{title}</h1>
          <button
            className="confirm-dialog-close-btn"
            onClick={handleCancel}
            aria-label="Close"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
        </div> */}

        {/* Content */}
        <div className="confirm-dialog-content">
          <div className="confirm-dialog-question">
            <p className="confirm-dialog-question-text">{questionText}</p>
          </div>
        </div>

        {/* Footer */}
        <div className="confirm-dialog-footer">
          <div className="confirm-dialog-actions">
            <button className="confirm-dialog-btn confirm-dialog-btn--cancel" onClick={handleCancel}>
              <span>{cancelText}</span>
            </button>
            <button className="confirm-dialog-btn confirm-dialog-btn--primary" onClick={handleContinue}>
              <span>{continueText}</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ConfirmationPopup;